import api from './utils/api';

class ReviewsService {
  async listReviews(modelId) {
    const result = await api.get(`/reviews/${modelId}`);
    return result.data;
  }

  async listAllReviews(modelId, filters = {}) {
    const params = {};
    if (filters.status) {
      params.status = filters.status;
    }

    const result = await api.get(`/reviews/show/${modelId}`, { params });
    return result.data;
  }

  async createReview({ modelId, score, comment }) {
    const result = await api.post(`/reviews`, {
      modelId,
      score,
      comment,
    });
    return result.data;
  }

  async updateReview({ clientId, modelId, show }) {
    const result = await api.put(`/reviews`, {
      clientId,
      modelId,
      show,
    });
    return result.data;
  }
}

export default new ReviewsService();
